import ModalProvision from '@/components/tresorerie/modal-approvisionner';
import DateFilter from '@/components/date-filter';
import ViewOperation from '@/components/tresorerie/tresorerie/manage-view';
import ManageVersementBanque from '@/components/tresorerie/manage-versement-banque'
import { openMenu, closeMenu, open_menu_state } from '@/function/function.js';
import store_operation from "@/store/mods/caisse/operations"
import store_compte from '@/store/mods/caisse/compte.js'
import operationsApi from '@/api/comptabilite/_operations'
import $ from 'jquery'


export default {
    name: 'tresorerie',
    components: {
        ModalProvision, DateFilter,
        ViewOperation, ManageVersementBanque
    },
    props: [],
    data() {
        return {
            vm_state: open_menu_state,
            months: [
                { id: 1, lib: "Janvier" },
                { id: 2, lib: "Février" },
                { id: 3, lib: "Mars" },
                { id: 4, lib: "Avril" },
                { id: 5, lib: "Mai" },
                { id: 6, lib: "Juin" },
                { id: 7, lib: "Juillet" },
                { id: 8, lib: "Août" },
                { id: 9, lib: "Septembre" },
                { id: 10, lib: "Octobre" },
                { id: 11, lib: "Novembre" },
                { id: 12, lib: "Décembre" },
            ],
            date: new Date(),

            is_empty: false,
            is_loading: true,
            fields: [
                { key: 'ref', label: 'Référence' }, 'date', { key: 'libelle', label: 'Libellé' },
                { key: 'moyen', label: 'Moyen' },
                { key: 'compte_sortant', label: 'Source' }, { key: 'compte_entrant', label: 'Destination' }, 
                { key: 'entree', label: 'Entrée' }, { key: 'sortie', label: 'Sortie' }, { key: 'action', label: 'Action.s' } 
            ],
            filter: "",
            currentPage: 1,
            total_pages: 1,
            total_rows: 0,
            journal_request_id: 0,      // Ignore les réponses d'une page / d'un filtre devenu obsolète
            search_timer: null,
            requested_search: '',
            print_rows: [],             // Toutes les lignes du journal, chargées au moment d'imprimer
            filename: '',
            is_printing: false,

            compte_id: 0,
            user_id: 0,
            type_period: 0,
            period: '',

            tot_provision: 0,
            tot_versement_recu: 0, 
            tot_depense: 0,
            solde: 0,

            versment_to_confirm: '',          // Montant du versement à confirmer
            provision_to_confirm: '',
            save_loading: false,
            confirmation: '',
            cash_received: 0,
            confirm_mixed_cash: false,
            selected_mobile_receipts: [],
            mixed_reception_error: '',
            electronic_reception_error: '',

            solde_compte_depot_loading: true,
            solde_compte_depense_loading: true,

            current_date_filter: {},
            curr_month: {
                id: 0,
                lib: "Filtre par mois"
            },          // Current month of the year
            filter_date: '',

            date_filters: [
                { slug: 'date', libelle: 'Date' },
                { slug: 'entre_deux_date', libelle: 'Entre deux dates' }
            ],
            filter_by_date: { slug: '', libelle: '' },

            view_toggler: 0,
            operation_tresorerie: {
                preuve: '',
                commentaire: ''
            },
            can_print: false,
            is_month: false,
            journal_tresorier: [],
            solde_courant_compte_depot: 0,
            solde_corant_compte_depense: 0,
            curr_date: "",
            vers_toggler: 0,
            solde_banque: {},
            solde_banque_loading: true,
            solde_error: '',
            compte_det: ''
        }
    },

    watch: {
        filter_date() {
            if (this.filter_date != '') {
                this.filter_by_date = this.filter_date;
                if (this.filter_by_date.slug) {
                    $('.date-filter').modal('show')
                }
            }
        },

        curr_month() {
            this.operations_tobe_canceled = []
            const data = {
                compte_id: this.compte_id,
                user_id: this.userCredentials.user.id,
                month: this.curr_month.id,
                one_date: "",
                from_date: "",
                to_date: "",
                role_id: 14
            }
            this.current_date_filter = data
            this.is_month = true

            this.currentPage = 1
            this.getJournalTresorerie(data)
        },

        filter() {
            clearTimeout(this.search_timer)
            this.search_timer = setTimeout(() => {
                if (this.filter === this.requested_search) return
                this.currentPage = 1
                this.getJournalTresorerie(this.current_date_filter)
            }, 400)
        },

        confirmation() {
            $('.err-cfrm').fadeOut(500)
        }
    },

    computed: {
        /**
         * User Info
         * @returns 
         */
        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        activeRole() {
            return this.$store.getters['activeRole'];
        },

        userCompte() {
            return this.$store.getters["compteActiveUser"];
        },

        /**
         * Liste of months of the year [ From january to current month ]
         * @returns 
         */
         monthOfYear() {
            let index;
            var m = []
            for (index = 0; index < this.date.getMonth() + 1; index++) {
                m[index] = this.months[index];
            }
            return m;
        },

        solde_tresorier() {
            return this.$store.getters["solde_tresorier"];
        },

        solde_compte_depot() {
            return this.$store.getters["solde_compte_depot"];
        },

        solde_compte_depense() {
            return this.$store.getters["solde_compte_depense"];
        },
    },

    mounted() {
        // this.curr_month = this.monthOfYear[this.date.getMonth()]

        //HIDE OPTIONS IF CLICKED ANYWHERE ELSE ON PAGE
        $(document).on("click", function(e) {
            let $clicked = $(e.target);
            this.v = 0;
            if (!$clicked.parents().hasClass("option-container")) {
                $(".option-box").removeClass("animate-fadeInRight");
                $(".option-box").addClass("animate-fadeOutRight");
                $(".option-box").fadeOut();
            }
        });

        if (this.userCredentials.user.roles.length > 0) {
            this.user_id = this.userCredentials.user.id
            this.user_role = this.userCredentials.user.roles[0].nom;

            if (this.activeRole.nom == 'ROLE_CAISSIERE') {
                this.compte_id = 1
                this.can_view_reglement_dette = true
            } else if (this.activeRole.nom == 'ROLE_CAISSIERE_INTERMITENT') {
                this.compte_id = 4
            } else if (this.activeRole.nom == 'ROLE_COMPTABLE') {
                this.compte_id = 3
            } else if (this.activeRole.nom == 'ROLE_TRESORERIE') {
                this.compte_id = 6
            }
        }

        const tmpstamp = this.date.getHours()+''+this.date.getMinutes()+''+this.date.getFullYear()
        this.filename = 'Journal trésorier_'+tmpstamp 

        const data = {
            compte_id: this.compte_id,
            user_id: this.userCredentials.user.id,
            month: "",
            one_date: this.setDates().today_date,
            from_date: "",
            to_date: "",
            role_id: 14
        }
        this.current_date_filter = data
        this.curr_date = data
        this.is_month = false

        this.getJournalTresorerie(data)
        this.getSoldeCourantCompteDeDepot()
        this.getSoldeCourantCompteDeDepense()

        this.getSoldeEnBanque()
    },

    beforeDestroy() {
        clearTimeout(this.search_timer)
    },

    methods: {
        /**
         * Open Menu Dropdown
         */
         openMenu(state, selector, show_in, show_out) {
            this.vm_state = openMenu.dropMenu(state, selector, show_in, show_out)
        },

        /**
         * Close Menu Dropdown
         */
        closeMenu(selector, show_in, show_out) {
            this.vm_state = closeMenu.wrapMenu(selector, show_in, show_out)
        },

        getSoldeCourantCompteDeDepot() {
            this.solde_compte_depot_loading = true
            const data = {
                compte_id: this.compte_id,
                user_id: this.userCredentials.user.id,
                month: "",
                one_date: this.setDates().today_date,
                from_date: "",
                to_date: "",
                role_id: 14
            }

            // Solde courant du compte de dépôt
            this.$store.dispatch('getSoldeCourantCompteDepot', data).then(() => {
                this.solde_compte_depot_loading = false
                this.solde_courant_compte_depot = this.solde_compte_depot
            })
        },

        getSoldeCourantCompteDeDepense() {
            this.solde_compte_depense_loading = true
            const data = {
                compte_id: this.compte_id,
                user_id: this.userCredentials.user.id,
                month: "",
                one_date: this.setDates().today_date,
                from_date: "",
                to_date: "",
                role_id: 14
            }

            // Solde courant du compte de dépôt
            this.$store.dispatch('getSoldeCourantCompteDepense', data).then(() => {
                this.solde_corant_compte_depense = this.solde_compte_depense
                this.solde_compte_depense_loading = false
            })
        },

        /**
         * Page courante du journal (25 lignes, recherche côté serveur)
         * Le total des dépenses porte sur toute la période, pas seulement sur la page affichée
         */
        getJournalTresorerie(data) {
            const request_id = ++this.journal_request_id
            this.requested_search = this.filter
            this.is_loading = true

            store_operation.getJournalTresorierPagine({ ...data, page: this.currentPage, search: this.filter }).then((journal) => {
                if (request_id != this.journal_request_id) return

                this.journal_tresorier = journal.data
                this.total_pages = journal.last_page
                this.total_rows = journal.total
                this.tot_depense = journal.total_depenses
                this.is_empty = (journal.total == 0 && !(journal.data || []).length)
                this.is_loading = false
            }).catch(() => {
                if (request_id != this.journal_request_id) return
                this.is_loading = false
            })
        },

        previousPage() {
            if (this.currentPage > 1) {
                this.currentPage--;
                this.getJournalTresorerie(this.current_date_filter)
            }
        },

        nextPage() {
            if (this.currentPage < this.total_pages) {
                this.currentPage++;
                this.getJournalTresorerie(this.current_date_filter)
            }
        },

        gotoPage(page) {
            if (page !== this.currentPage) {
                this.currentPage = page;
                this.getJournalTresorerie(this.current_date_filter)
            }
        },

        filterByDate(date) {
            const data = {
                compte_id: this.compte_id,
                user_id: this.userCredentials.user.id,
                month: "",
                one_date: date.single_date,
                from_date: date.from_date,
                to_date: date.to_date,
                from_hour: date.from_hour,
                to_hour: date.to_hour,
                role_id: 14
            }
            this.current_date_filter = data
            this.filter_date = ""
            this.is_month = false

            this.currentPage = 1
            this.getJournalTresorerie(data)
        },

        viewProof(data) {
            this.view_toggler = (this.view_toggler == 0)?1:0

            this.operation_tresorerie = data
        },


        refreshOperation() {
            this.getJournalTresorerie(this.current_date_filter)
            this.getSoldeCourantCompteDeDepot()
            this.getSoldeCourantCompteDeDepense()
            this.getSoldeEnBanque()
        },

        /**
         * Cache le message d'erreur au click du checkbox
         */
        onConfirm() {
            $('.err-msg').fadeOut(500);
        },

        confirmer(data) {
            this.versment_to_confirm = data
            this.cash_received = data.bordereau_mobile ? Number(data.bordereau_mobile.montant_especes) : 0
            this.confirm_mixed_cash = false
            this.selected_mobile_receipts = []
            this.mixed_reception_error = ''
            this.electronic_reception_error = ''
        },

        confirmerProvision(data) {
            this.provision_to_confirm = data

            if (this.provision_to_confirm.compte_source == 'Compte de dépôt') {
                this.compte_det = 'le Compte de dépôt'
            } else if (this.provision_to_confirm.compte_source == 'Subvention') {
                this.compte_det = 'Subvention'
            } else if (this.provision_to_confirm.compte_source == 'Banque') {
                this.compte_det = 'la Banque'
            } else if (this.provision_to_confirm.compte_source == 'Don') {
                this.compte_det = 'Don'
            } else if (this.provision_to_confirm.compte_source == 'Prêt') {
                this.compte_det = 'Prêt'
            }
        },

        /**
         * Confirmation d'un versement
         */
        saveConfirmation(v) {
            if (v == 1 && this.versment_to_confirm.versement_electronique) {
                this.saveElectronicReception()
                return
            }
            if (v == 1 && this.versment_to_confirm.bordereau_mobile) {
                this.saveMixedReception()
                return
            }
            let confirm, confirm_state = ''
            if (v == 1) {
                confirm = document.getElementById('cfrm-versm');

                if (confirm.checked == false) { //  Vérifie si l'utilisateur a confirmé 
                    $('.err-msg').fadeIn(500)
                    return;
                }
                confirm_state = 1
            } else {
                if (this.confirmation == "") { //  Vérifie si l'utilisateur a confirmé 
                    $('.err-cfrm').fadeIn(500)
                    return;
                }
                confirm_state = this.confirmation
            }
            
            this.save_loading = true
            const operation_id = (v == 1)?this.versment_to_confirm.id:this.provision_to_confirm.id
            const data = {
                operation_id: operation_id,
                is_confirm: confirm_state,
                is_versement: v
            }

            this.$store.dispatch('confirmerVersement', data).then((response) => {
                if (response > 0) {
                    if (v == 1) {
                        this.$refs.cfrn_versm.click()
                    } else {
                        this.$refs.cfrn_approv.click()
                    }
                    
                    this.successToast("Confirmation effectuée avec succès")

                    this.refreshOperation()
                }
                this.save_loading = false
            }).catch(() => {
                this.save_loading = false
                this.warningToast('La confirmation du mouvement a échoué. Vérifiez vos droits et réessayez.')
            })
        },

        async saveMixedReception() {
            const bordereau = this.versment_to_confirm.bordereau_mobile
            const cashPending = !bordereau.especes_confirmees
            const confirmCash = cashPending && (this.confirm_mixed_cash || Number(bordereau.montant_especes) === 0)
            if (!confirmCash && !this.selected_mobile_receipts.length) {
                this.mixed_reception_error = 'Confirmez les espèces reçues ou cochez les transactions vérifiées sur le portefeuille du centre.'
                return
            }
            if (confirmCash && (this.cash_received === '' || this.cash_received === null || !Number.isInteger(Number(this.cash_received)))) {
                this.mixed_reception_error = 'Indiquez le montant exact des espèces réellement reçues.'
                return
            }
            this.mixed_reception_error = ''
            this.save_loading = true
            try {
                const response = await operationsApi.confirmerVersementMixte({
                    operation_id: this.versment_to_confirm.id,
                    montant_especes_recu: confirmCash ? Number(this.cash_received) : null,
                    mobile_ids: this.selected_mobile_receipts.slice(),
                })
                if (!response.success) throw new Error('La réception n’a pas été enregistrée.')
                $('.cfrm-versement').modal('hide')
                if (response.ecart_especes !== null && response.ecart_especes !== undefined) {
                    this.warningToast(`Écart d’espèces de ${this.formatCurrency(Math.abs(response.ecart_especes))} ${bordereau.devise_especes} enregistré. Les espèces restent à confirmer.`)
                } else {
                    this.successToast(response.reception_complete
                        ? 'Bordereau reçu et rapproché.' : 'Réception partielle enregistrée. Le reste demeure en attente.')
                }
                this.refreshOperation()
            } catch (error) {
                const details = error.response && error.response.data
                const validation = details && details.errors && Object.values(details.errors)[0]
                this.mixed_reception_error = Array.isArray(validation) ? validation[0] :
                    (details && details.message) || error.message || 'Impossible de confirmer ce bordereau.'
            } finally {
                this.save_loading = false
            }
        },

        async saveElectronicReception() {
            const versement = this.versment_to_confirm
            const detail = versement.versement_electronique
            if (!detail || detail.confirme) return
            this.save_loading = true
            this.electronic_reception_error = ''
            try {
                const response = await operationsApi.confirmerVersementElectronique({
                    ticket_ids: detail.tickets.map(ticket => ticket.ticket_id),
                    caissier_id: Number(versement.user_id),
                    date: String(versement.date).slice(0, 10),
                    devise: detail.devise,
                    montant_attendu: Number(detail.total)
                })
                if (!response.success) throw new Error('Versement électronique non validé.')
                $('.cfrm-versement').modal('hide')
                this.successToast('Monnaie électronique validée et ajoutée au compte de dépôt.')
                this.refreshOperation()
            } catch (error) {
                const details = error.response && error.response.data
                const validation = details && details.errors && Object.values(details.errors)[0]
                this.electronic_reception_error = Array.isArray(validation) ? validation[0] :
                    (details && details.message) || error.message || 'Validation impossible.'
            } finally {
                this.save_loading = false
            }
        },

        printJournalTresor() {
            this.is_printing = true

            store_operation.getJournalTresorier({ ...this.current_date_filter, search: this.filter }).then((journal) => {
                this.print_rows = journal
                this.is_printing = false
                this.can_print = true

                setTimeout(() => {
                    window.print()
                    this.can_print = false
                }, 500);
            }).catch(() => {
                this.is_printing = false
            })
        },

        addVersement() {
            this.vers_toggler = (this.vers_toggler == 0)?1:0
            $('.m-versement').modal('show')
        },

        viewBanque() {
            $('.view-solde-banque').modal('show')
        },
        
        getSoldeEnBanque() {
            this.solde_banque_loading = true
            store_compte.getSoldeBanque().then((response) => {
                this.solde_banque = response

                this.solde_banque_loading = false
            }).catch(() => {    
                this.solde_error = "Une erreur s'est produite !"
                this.solde_banque_loading = false 
            })
        }
    }
}


